import { View } from "ui/atoms/view";
import { AssessmentsTableTemplate } from "../templates/AssessmentsTableTemplate";
import { Portal } from "ui/modules/ThrelsPortal/Portal";
import { PermissionCheck } from "app/features/permission/atoms/PermissionCheck";
import { PermissionsEnums } from "app/services/api/types/authorisation/enums/PermissionsEnums";
import { ButtonLink } from "ui/gluestack/button";
import { ButtonText } from "ui/gluestack/button";
import { ButtonIcon } from "ui/gluestack/button";
import { AddIcon } from "ui/gluestack/icon";

export default function AssessmentsListingScreen() {
  return (
    <View className="flex-1 bg-white">
      <Portal hostName="headerButton" identifier="residentList">
        <PermissionCheck
          permission={PermissionsEnums.CREATE_FORM}
          fallback={<></>}
        >
          <ButtonLink
            href="/assessments/add"
            variant="solid"
            action="primary"
            size="sm"
          >
            <ButtonText>Add new form</ButtonText>
            <ButtonIcon as={AddIcon} className="w-4 h-4" />
          </ButtonLink>
        </PermissionCheck>
      </Portal>
      <AssessmentsTableTemplate />
    </View>
  );
}
